import { LFlex } from "@components";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Note, prettyPrintRoleIds } from "@store/generalTypes";
import { format } from "date-fns";

export const ExistingNotes = ({ notes, showDetail }: { notes: Note[]; showDetail?: boolean }): JSX.Element => {
    return (
        <>
            {showDetail
                ? notes.map((note, i) => {
                      return (
                          <LFlex key={`${note.id}-${i}`} className={`${i !== notes.length - 1 ? "mb-2" : ""}`}>
                              <LFlex
                                  row
                                  alignCenter
                                  className="is-justify-content-space-between is-size-6 mb-2 has-text-ldark-gray"
                              >
                                  {note.text}
                              </LFlex>
                              <LFlex row alignCenter>
                                  <FontAwesomeIcon icon={solid("circle-user")} size={"2x"} color="#D8E4EB" />
                                  <LFlex>
                                      <p className="is-size-6h has-text-ldark-gray ml-2">
                                          {`${note.firstName} ${note.lastName}, `}
                                          <span className="has-text-weight-bold">{prettyPrintRoleIds(note.roles)}</span>
                                      </p>
                                      <p className="is-size-6h has-text-ldark-gray ml-2">
                                          {format(new Date(note.createdDate), "MMM dd, yyyy")}
                                      </p>
                                  </LFlex>
                              </LFlex>
                              {i !== notes.length - 1 && <span className="has-text-accent-dolphin mt-2">—</span>}
                          </LFlex>
                      );
                  })
                : notes.map((note, i) => {
                      return (
                          <LFlex key={`${note.id}-${i}`} className={`${i !== notes.length - 1 ? "mb-2" : ""}`}>
                              <LFlex row alignCenter className="is-justify-content-space-between is-size-6h">
                                  {note.text}
                                  {/* <LBtn variation="unstyled" smallSpacing smallTopBottomMargins noSpacing disabled> */}
                                  {/* Edit */}
                                  {/* </LBtn> */}
                              </LFlex>
                              <p className="is-size-7 has-text-ldark-gray">
                                  {`${note.firstName} ${note.lastName}`},{" "}
                                  <span className="has-text-weight-bold">{prettyPrintRoleIds(note.roles)}</span> -{" "}
                                  {format(new Date(note.createdDate), "MMM dd, yyyy")}
                              </p>
                          </LFlex>
                      );
                  })}
        </>
    );
};
